import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  padding: 40px 20px;
`;

const Container = styled.div`
  max-width: 900px;
  margin: auto;
  background: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
`;

const Title = styled.h1`
  font-size: 32px;
  margin-bottom: 30px;
`;

const Section = styled.div`
  margin-bottom: 24px;
`;

const SubTitle = styled.h3`
  font-size: 20px;
  margin-bottom: 8px;
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #555;
  white-space: pre-line;
`;

const TermsConditions = () => {
  const { t } = useTranslation();

  // Fetch terms from translation JSON
  const terms = t("terms", { returnObjects: true });

  return (
    <Wrapper>
      <Container>
        <Title>{terms.title}</Title>

        <Text style={{ marginBottom: "30px" }}>{terms.intro}</Text>

        {terms.sections.map((section) => (
          <Section key={section.number}>
            <SubTitle>
              {section.number} {section.title}
            </SubTitle>
            <Text>{section.content}</Text>
          </Section>
        ))}
      </Container>
    </Wrapper>
  );
};

export default TermsConditions;
